<template>
    <div class="Section Section-Cart-Items">
      <template v-for="cart_item in cart">
        <item-row :cart_item="cart_item" :can_remove="can_remove" :currency="active_module.currency"></item-row>
      </template>
    </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import ItemRow from './_partials/items-row.vue';

  export default {
    components: { ItemRow },
    props: [
      'display_coupon',
      'can_remove',
    ],

    data: function () {
      return {
        code: '',
      };
    },

    computed: {
      ...mapGetters([
        'amount_with_modifiers_normal',
        'amount_with_modifiers_normal_after_coupon',
        'visitor_modifiers',
        'active_module',
        'cart'
      ]),
      count () {
        return this.$store.state.count;
      },
    },

    methods: {
      ...mapActions([
        'delete_item',
        'update_quantity',
        'apply_coupon',
        'remove_coupon',
      ]),

      confirm_delete (product_id) {
        this.delete_item(product_id);
//        let answer = window.confirm('Ürünü silmek istediğinizden emin misiniz?')
//        if (answer) {
//        } else {
//        }
      },
      confirm_coupon (code) {
        this.apply_coupon({ code: code });
        this.code = '';
      },
    },
    watch: {
      '$route' (to, from) {
        // react to route changes...
        // console.log('ROUTECHANGE:', to, from)
      }
    },

  };
</script>

<style scoped>
  .Section {
    padding: 4%;
  }

  .Section-Cart-Items {
    /* margin-top: 15px; */
    background-color: #FAFAFA;
    box-shadow: inset 0px 2px 4px -1px rgba(140,140,140,.2);
  }

</style>



// WEBPACK FOOTER //
// Cart.vue?97520aa2